<template>
	<div class="container">
		<div v-html="page.body"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			page: {
				body: `
					<div class="row clearfix">
						<div class="column full" style="margin: 0 auto;">
							<p style="text-align: center;" class="size-14">SERVIVE</p>
							<h3 style="text-align: center;">店頭で受けれるサービス</h3>
						</div>
					</div>
					<div class="row clearfix">
						<div class="column full">
							<p style="text-align: center; letter-spacing: 1px;">
								この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。
								<br />この文章はダミーです。文字の大きさ、量、字間、行間等を確認するために入れています。
								<br />
							</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix">
						<div class="column full">
							<div class="spacer height-40"></div>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt />
						</div>
						<div class="column half">
							<p style="text-align: justify;">
								<b class="size-18">タンブラー持参で20円割引</b>
							</p>
							<p>お好きなタンブラーをご持参頂くとお会計から割引致します。</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix" style="flex-direction: row-reverse;" draggable="false">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt draggable="false" />
						</div>
						<div class="column half">
							<p style="text-align: left;">
								<b class="size-18">コーヒー袋やキャニスター持参で５％増量</b>
							</p>
							<p>お好きな容器をご持参頂くとコーヒー豆をその場で増量致します。</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt />
						</div>
						<div class="column half">
							<p style="text-align: justify;">
								<b class="size-18">ドリンクチケット１０杯分/ビーンズチケット200g８袋分</b>
							</p>
							<p>
								ドリンクやコーヒー豆がお得になるお得な回数券、最大1,000～2,000円程度お得に！
								お好きなタイミングをご利用頂けます。※有効期限は１年間です
							</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix" style="flex-direction: row-reverse;" draggable="false">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt draggable="false" />
						</div>
						<div class="column half">
							<p style="text-align: justify;">
								<b class="size-18">ギフトラッピング</b>
							</p>
							<p>
								冠婚葬祭に限らずどんなシーンにも対応したギフトをご提案致します。
								ご予算に合わせた内容で相談しながら決められるので安心です。
							</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt />
						</div>
						<div class="column half">
							<p style="text-align: justify;">
								<b class="size-18">全国発送</b>
							</p>
							<p>
								全国発送（佐川急便）も提携店ならではのお得な価格でご提供致します。
								さらに4,000円以上のお買い上げで送料無料になります。
							</p>
						</div>
					</div>
					<div class="spacer height-20"></div>
					<div class="row clearfix" style="flex-direction: row-reverse;">
						<div class="column half">
							<img src="assets/img/official_img/coffeehaus/DSC03845.jpg" alt />
						</div>
						<div class="column half">
							<p style="text-align: justify;">
								<b class="size-18">ポットサービス</b>
							</p>
							<p>
								お友達とのお茶会や会議でのコーヒーに当店のコーヒーはいかがでしょうか？
								淹れたてをご用意致します。カップやシュガーやミルクも当店から支給致します。
							</p>
						</div>
					</div>
					<div class="row clearfix">
						<div class="column full" data-noedit>
							<div class="spacer height-80"></div>
						</div>
					</div>
					<div class="row clearfix">
						<div class="column full" data-noedit>
							<div class="spacer height-40"></div>
						</div>
					</div>`
				}
			};
		}
	};
</script>

<style lang="scss">

</style>